export default __webpack_public_path__ + "assets/images/7327cbfabc5b7552b52e701e608d10ad.png";